import styled from "@emotion/styled"
import TextsWrapper from "components/Texts/TextsWrapper"

const TextThreeWrapper = styled(TextsWrapper)``

export default TextThreeWrapper
